// src/components/insights/References.jsx

import { useCitationContext } from "./citationContext";

function linkifyDOI(text) {
  const doiRegex = /(https?:\/\/doi\.org\/[^\s]+)/g;

  return text.split(doiRegex).map((part, index) => {
    if (part.match(doiRegex)) {
      return (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
        >
          {part}
        </a>
      );
    }

    return part;
  });
}

function References({ items }) {
  const { orderedIds } = useCitationContext();

  return (
    <div className="references">
      <h2>References</h2>

      <ol>
        {orderedIds.map((id) => (
          <li key={id} id={`ref-${id}`}>
            {linkifyDOI(items[id])}
          </li>
        ))}
      </ol>
    </div>
  );
}

export default References;